exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination li:not(.active) .disabled[data-v-23787d39] {\n}\n.pagination.loading a[data-v-23787d39] {\n  cursor: wait !important;\n}\n", ""]);

// exports
